import request from '../lib/request';

export default async function recordPageView() {
  try {
    await request(PATHS.apiV1RawPageViewStatsPath, 'POST', { user_id: GLOBALS.userId });
  } catch (error) {
    Sentry.captureException(error);
  }
}
